import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
const sFPControllerEndpoint = 'FirmPurchasesExcel';
const sBrandModelControllerEndpoint = 'BrandModel';
const sTransportControllerEndpoint = 'TransportExcel';


export class ExcelAPI {

  getExcelCarsList(L1Id = 0) {
    let params = {
      L1Id: L1Id
    }
    return axios.get(getBackendURL() + sFPControllerEndpoint + '/GetCarsListExcel', { params });
  };

  postExcelFile(formData, ForceSave, id) {
    return axios.post(getBackendURL() + sFPControllerEndpoint + '/PostExcelFile?ForceSave=' + ForceSave + '&loteId=' + id, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  };

  postBrandModelExcelFile(formData) {
    return axios.post(getBackendURL() + sBrandModelControllerEndpoint, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  };

  getExcelTransportCarsListByLot(L1Id = 0) {
    let params = {
      L1Id: L1Id
    }
    return axios.get(getBackendURL() + sTransportControllerEndpoint + '/GetTransportExcelByLot', { params });
  };

  postExcelTransportCarsListByLot(formData, L1Id) {
    return axios.post(getBackendURL() + sTransportControllerEndpoint + '/PostTransportExcelByLot?L1Id=' + L1Id, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  };

  getExcelWRTCarsList() {
    return axios.get(getBackendURL() + sTransportControllerEndpoint + '/GetWRTExcel');
  };

  getExcelWADCarsList() {
    return axios.get(getBackendURL() + sTransportControllerEndpoint + '/GetWADExcel');
  };

  getExcelAtDCarsList() {
    return axios.get(getBackendURL() + sTransportControllerEndpoint + '/GetAtDExcel');
  };

  postExcelTransportCarsList(formData) {
    return axios.post(getBackendURL() + sTransportControllerEndpoint + '/PostTransportExcel', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  };

}

export default ExcelAPI


// WEBPACK FOOTER //
// ./src/API/ExcelAPI.js